export default __webpack_public_path__ + "static/media/Detail-D'Syrikah.fa8d8512.png";